import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getUrl } from '../../_shared/utils';
import { JWTTokenService } from '../jwtToken.service';
import { QRCode, QRCodePricingTier } from '../../_models/fundraising/QRCode';

@Injectable()
export class QRCodeService {
    public apiUrl = getUrl();

    constructor(
        private http: HttpClient,
        private jwtTokenService: JWTTokenService) { }

    public getCodes(): Observable<QRCode[]>{
        return this.http.get<QRCode[]>(getUrl("fundraising/qr/codes"), this.requestOptionsAuthenticated('portal'));
    }

    public addNewCode(): Observable<QRCode>{
        return this.http.post<QRCode>(getUrl("fundraising/qr/add"), null, this.requestOptionsAuthenticated('portal'));
    }

    public updateQRCode(id: number): Observable<any>{
        return this.http.post<any>(getUrl(`fundraising/qr/update/${id}`), null,this.requestOptionsAuthenticated('portal'));
    }

    public getPricingTierLinksForCode(id: number): Observable<QRCodePricingTier[]>{
        return this.http.get<QRCodePricingTier[]>(getUrl(`fundraising/qr/pricing-tiers/${id}`), this.requestOptionsAuthenticated('portal'));
    }

    public getAllPricingTierLinks(): Observable<QRCodePricingTier[]>{
        return this.http.get<QRCodePricingTier[]>(getUrl(`fundraising/qr/pricing-tiers`), this.requestOptionsAuthenticated('portal'));
    }

    public updateVendorCodes(data: QRCode[]): Observable<any>{
        return this.http.post<any>(getUrl('fundraising/qr/update-codes'), data, this.requestOptionsAuthenticated('portal'));
    }

    public updatePricingTierLinks(data: QRCodePricingTier[]): Observable<any>{
        return this.http.post<any>(getUrl('fundraising/qr/pricing-tiers/update'), data, this.requestOptionsAuthenticated('portal'));
    }

    private requestOptionsAuthenticated(tokenKey: string) {
        const requestOptions = {
            headers: new HttpHeaders()
                .set('Content-type', 'application/json')
                .append('Authorization', 'Bearer ' + this.jwtTokenService.getToken(tokenKey)),
        };
        return requestOptions;
    }
}